var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCrossSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.7625,
    y1: 0.353553,
    x2: 1.42109,
    y2: 10.695,
    stroke: "#8AA1C3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5567,
    y1: 10.695,
    x2: 1.21532,
    y2: 0.353582,
    stroke: "#8AA1C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossSmall);
export default __webpack_public_path__ + "static/media/close-cross--small.4f97aa4ad103aa86b13cc788e2006fcf.svg";
export { ForwardRef as ReactComponent };